//FormulaBuilder components
import elementTypes from "../Elements/elementTypes"
import FormulaBuilderDragIcon from "./FormulaBuilderDragIcon"
import formulaBuilderTypes from "./formulaBuilderTypes"

//PrimeReact
import { Tooltip } from "primereact/tooltip"

//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormulaBuilder.module.css"

export default function FormulaBuilderQuestionOptionEntry({ option }) {
  let name = option?.text ?? "Unknown option"
  let textTooltip = undefined
  let typeProfile = elementTypes.findTypeProfile(elementTypes.optionElementId)

  if (name?.length > 100) {
    name = name?.substring(0, 100) + "..."
    textTooltip = name
  }

  return (
    <>
      <div className={`${myStyles.questionLayout} ${myStyles.container}`}>
        <Tooltip
          target={".tt-optionType"}
          className={myStyles.numberToolTip}
          position="left"
        />
        <div
          className={`${myStyles.questionLayoutIcon} tt-optionType`}
          data-pr-tooltip={typeProfile?.label}
        >
          <span className="material-icons">{typeProfile?.icon}</span>
        </div>
        <div
          className={`${myStyles.questionLayoutText}  tt-optionType`}
          data-pr-tooltip={textTooltip}
          data-pr-position="bottom"
        >
          {name}
        </div>

        <div className={myStyles.questionLayoutDragIcon}>
          <FormulaBuilderDragIcon
            id={option.id}
            type={formulaBuilderTypes.formulaTypes.option}
            object={option}
          />
        </div>
      </div>
    </>
  )
}
